import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../i18n';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Finnish as default language
  const [currentLanguage, setCurrentLanguage] = useState('fi');

  useEffect(() => {
    // Check for saved language preference
    const savedLanguage = localStorage.getItem('sunsari-language');
    if (savedLanguage && ['fi', 'en', 'sv'].includes(savedLanguage)) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (language) => {
    setCurrentLanguage(language);
    localStorage.setItem('sunsari-language', language);
  };

  // Follow the top-bar FI/SV/EN switch (react-i18next)
  useEffect(() => {
    const onChange = (lng) => {
      const code = (lng || '').slice(0, 2);
      if (['fi', 'en', 'sv'].includes(code)) changeLanguage(code);
    };
    i18n.on('languageChanged', onChange);
    return () => i18n.off('languageChanged', onChange);
  }, []);

  const value = {
    currentLanguage,
    changeLanguage,
    languages: {
      fi: 'Suomi',
      en: 'English', 
      sv: 'Svenska'
    }
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};